'use client'

import Script from 'next/script'
import { useEffect, useRef } from 'react'

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        dataLayer: Record<string, any>[]
    }
}

interface GTMHeaderScriptsProps {
    gtmKey: string
    nonce: string | null
}

export const GTMHeaderScripts = ({ gtmKey, nonce }: GTMHeaderScriptsProps) => {
    const hasInitializedDataLayer = useRef(false)

    useEffect(() => {
        if (hasInitializedDataLayer.current) {
            return
        }

        hasInitializedDataLayer.current = true
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js',
        })
    }, [gtmKey])

    return (
        <Script
            id="gtm-script"
            strategy="afterInteractive"
            src={`https://www.googletagmanager.com/gtm.js?id=${gtmKey}`}
            nonce={nonce}
        />
    )
}
